import { generateId } from '../../components/utils/helpers';

export const canva = () => {
  const id = generateId();
  const itemId = `icon-canva-itemId-${id}`;

  return (
    <>
      <rect
        x="1"
        y="1"
        width="22"
        height="22"
        rx="11"
        fill={`url(#${itemId})`}
      />
      <path
        d="M16.2255 15.9765C15.4865 16.656 15.0065 17.123 13.9315 17.6725C13.3155 17.98 12.623 18.165 11.9695 18.165C10.009 18.165 9.053 16.36 8.8625 14.801C8.374 10.8015 11.8885 5.304 14.339 5.304C14.9105 5.304 15.421 5.801 15.516 6.5755C15.663 7.781 15.639 8.6355 14.3925 9.677C14.256 9.7905 14.216 9.975 14.2865 10.084C14.3925 10.247 14.7275 10.2635 15.4045 9.921C16.7305 9.252 17.2085 8.219 17.0625 7.023C16.9 5.696 15.742 4.585 14.189 4.585C13.434 4.585 12.6035 4.8105 11.862 5.262C8.6305 7.2305 6.5455 11.7225 6.9645 15.1485C7.097 16.2355 7.549 17.4255 8.4025 18.2255C8.978 18.7585 10.018 19.415 11.244 19.415C12.5715 19.415 13.6925 18.9025 14.698 18.268C15.3795 17.8315 15.9495 17.3035 16.431 16.763C17.2205 16.029 16.6525 15.5735 16.2255 15.9765Z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="white"
        strokeWidth="0.5"
        stroke="white"
      />
      <defs>
        <linearGradient
          id={itemId}
          x1="22.492"
          y1="23.5715"
          x2="1.8115"
          y2="0.762999"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#823AF3" />
          <stop
            offset="0.36"
            stopColor="#4B66E1"
          />
          <stop
            offset="0.906"
            stopColor="#01F1C4"
          />
        </linearGradient>
      </defs>
    </>
  );
};
